import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers } from 'recompose';
import { injectIntl } from 'react-intl';

import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { isRtl } from 'modules/language/selectors/language';
import { fetchAppointmentsByQueueType } from 'modules/queues/common/actions/fetchAppointmentsByQueueType';
import { getAppointmentsByQueueType } from 'modules/queues/common/selectors/appointmentsByQueueType';
import { UNENFORCED, ARCHIVED } from 'modules/queues/constants/queueEnforcementTypes';
import { openArchive, closeArchive } from 'modules/queues/Archive/actions/archive';
import { redirectTo } from 'modules/auth/actions/redirectAction';
import { canCreateAppointmentSelector } from 'modules/queues/common/selectors/appointmentForm';

import AppointmentsSidebar from './AppointmentsSidebar';

const mapStateToProps = (state) => {
  const requestStatus = getAppointmentsByQueueType(state).status;
  const archiveOpened = state.queues.common.appointmentInfo.isArchiveOpened;
  const { hideArchive } = state.common.organizationConfig.appointmentConfig;
  const appointmentsTotal = archiveOpened
    ? state.queues.common.appointmentInfo.queuesSize[ARCHIVED]
    : state.queues.common.appointmentInfo.queuesSize[UNENFORCED];

  return {
    requestStatus,
    archiveOpened,
    hideArchive,
    appointmentsTotal,
    showAppointmentFormBtn: canCreateAppointmentSelector(state),
    rtl: isRtl(),
  };
};

const mapDispatchToProps = {
  openArchive,
  closeArchive,
  fetchAppointmentsByQueueType,
};

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  lifecycle({
    componentDidMount() {
      const { requestStatus, fetchAppointmentsByQueueType } = this.props;
      if (requestStatus === requestsStatuses.default) {
        fetchAppointmentsByQueueType();
      }
    },
    componentDidUpdate(prevProps) {
      const { archiveOpened, fetchAppointmentsByQueueType } = this.props;
      if ((prevProps.archiveOpened !== archiveOpened)) {
        fetchAppointmentsByQueueType();
      }
    },
  }),
  withHandlers({
    openAppointmentForm: () => () => redirectTo('/appointment/create'),
  }),
)(AppointmentsSidebar);
